import { render, staticRenderFns } from "./project-avatar.vue?vue&type=template&id=65faa066&scoped=true&"
import script from "./project-avatar.vue?vue&type=script&lang=js&"
export * from "./project-avatar.vue?vue&type=script&lang=js&"
import style0 from "./project-avatar.vue?vue&type=style&index=0&id=65faa066&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65faa066",
  null
  
)

export default component.exports